import React from 'react';

const SOCIALS = [
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/motion.reality/',
    path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z',
  },
  {
    name: 'X',
    href: 'https://x.com/MotionRealityUK',
    path: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/@MotionRealityRacing',
    path: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
  },
  {
    name: 'TikTok',
    href: 'https://www.tiktok.com/@motionrealitysimracing',
    path: 'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.86-.5-4.12-1.23-.09-.06-.19-.1-.27-.16-.01 2.27-.01 4.54-.03 6.81-.07 1.65-.65 3.27-1.61 4.61-1.47 2.01-3.96 3.26-6.46 3.09-2.02-.13-3.95-1.18-5.19-2.79-1.55-2.01-1.86-4.87-.79-7.16 1.07-2.39 3.55-4.04 6.17-4.05.03 1.4-.03 2.79.04 4.18-.94-.31-2.01-.27-2.91.24-1.11.61-1.78 1.87-1.69 3.13.07 1.57 1.49 2.93 3.07 2.88 1.56-.06 2.89-1.06 2.89-2.67 0-2.79.02-5.57-.02-8.35.01-1.4.03-2.79.04-4.18z',
  },
  {
    name: 'Twitch',
    href: 'https://www.twitch.tv/motion_reality',
    path: 'M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.857 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z',
  },
  {
    name: 'Patreon',
    href: 'https://www.patreon.com/c/MotionRealitySimRacingLtd',
    path: 'M0 .857v22.286h3.818V.857H0zm14.286 0c-5.346 0-9.686 4.34-9.686 9.686 0 5.345 4.34 9.686 9.686 9.686 5.345 0 9.686-4.341 9.686-9.686 0-5.346-4.341-9.686-9.686-9.686z',
  },
];

export default function SocialLinks({ className = '' }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {SOCIALS.map((s) => (
        <a
          key={s.name}
          href={s.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={s.name}
          title={s.name}
          className="w-9 h-9 flex items-center justify-center border border-white/10 text-white/50 hover:text-white hover:border-primary/50 hover:bg-primary/10 transition-colors"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" aria-hidden="true">
            <path d={s.path} />
          </svg>
        </a>
      ))}
    </div>
  );
}